import { getSharedStores } from '../../stores/shared';
import { twitchJoinChannel, twitchLeaveChannel } from '../apiV2';

const state = getSharedStores();

export const initializeTwitchSettingsEvents = () => {
  let cachedTwitchSettingsState = state.twitchSettingsState.currentState;
  state.twitchSettingsState.addListener(async (twitchState) => {
    if (!cachedTwitchSettingsState.twitchDisplayName && twitchState.twitchDisplayName !== '') {
      // we logged in for the first time
      console.log('[TWITCH] logged in for the first time');
      console.warn('[TWITCH] joining channel');
      twitchJoinChannel();
    }
    if (!cachedTwitchSettingsState.isTwitchBotEnabled && twitchState.isTwitchBotEnabled) {
      // we enabled the bot
      // join channel
      if (state.authState.currentState.hostAuthId.startsWith('user')) {
        console.warn('[TWITCH] joining channel');
        twitchJoinChannel();
      } else {
        console.warn('[TWITCH] waiting for user auth');
        const listener = state.authState.addListener((authState) => {
          if (authState.hostAuthId.startsWith('user')) {
            console.warn('[TWITCH] joining channel');
            twitchJoinChannel();
            state.authState.removeListener(listener);
          }
        });
      }
    }
    if (cachedTwitchSettingsState.isTwitchBotEnabled && !twitchState.isTwitchBotEnabled) {
      // we disabled the bot
      // leave channel
      twitchLeaveChannel();
    }
    cachedTwitchSettingsState = twitchState;
  });
  // set a timeout to check the state of the bot

  if (state.authState.currentState.hostAuthId.startsWith('user')) {
    console.warn('[TWITCH] joining channel, delayed');
    twitchJoinChannel();
  } else {
    const listener = state.authState.addListener((authState) => {
      if (authState.hostAuthId.startsWith('user')) {
        console.warn('[TWITCH] joining channel, delayed');
        twitchJoinChannel();
        state.authState.removeListener(listener);
      }
    });
  }
};
